import { render } from "./newbieTutorial.vue?vue&type=template&id=6b707f4e&scoped=true"
import script from "./newbieTutorial.vue?vue&type=script&lang=js"
export * from "./newbieTutorial.vue?vue&type=script&lang=js"

import "./newbieTutorial.vue?vue&type=style&index=0&id=6b707f4e&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b707f4e"]])

export default __exports__